// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3400":"11c5a680","4673":"d48da143"}[chunkId] + ".chunk.css";
};